import { useDispatch } from 'react-redux';
import { Button, CircularProgress, Dialog } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import useKYCResponse from '../../hooks/useKYC';
import { IsAllow, SET_KYC_REGISTRATION_POPUP } from '../../redux-store/types/portfolio';
import { kycNotVerified, MESSAGE_MAP, NOT_VERIFIED } from './utils';

type RegistrationProps = {
    amc: string;
    isin?: string;
};
type KYCProps = {
    handleKYCFailure?: Function | null;
    /**
       allowRegistration let us know if registration popup should be shown, it should be an object that 
       takes isin and amc.
     */
    callApi?: boolean;
    allowRegistration: RegistrationProps;
};

export const KYCCheck = ( { callApi = true, ...props}: KYCProps) => {
    const history = useHistory();
    const [open, setOpen] = useState(false);
    const { kycVerified, loading } = useKYCResponse({
        callApi,
        amc: props.allowRegistration.amc,
    });
    const dispatch = useDispatch();

    useEffect(() => {
        let isCustomPopup = false
        if (kycVerified.value === IsAllow.No && kycVerified.message && callApi) {
            if (kycVerified.message === NOT_VERIFIED) {
                const { isin, amc } = props.allowRegistration;
                dispatch({
                    type: SET_KYC_REGISTRATION_POPUP,
                    body: { kycRegistrationPopup: { isin, amc } },
                });
            } else if (kycNotVerified(kycVerified.message)) {
                setOpen(true);
                isCustomPopup = true;
            } else {
                alert('KYC status is: ' + kycVerified.message);
            }
            if(!isCustomPopup) {
                if (props.handleKYCFailure) {
                    props.handleKYCFailure();
                } else {
                    history.goBack();
                }
            }
        }
    }, [kycVerified, callApi]);
    if (loading)
        return (
            <Dialog
                maxWidth={'sm'}
                open={!kycVerified.value}
                aria-labelledby="enable-fingerprint-modal"
            >
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '12px' }}>{'Checking KYC Status...'}</p>
                </div>
            </Dialog>
        );
    return (
        <KYCInvalid
            open={open}
            setOpen={setOpen}
            message={MESSAGE_MAP[kycVerified?.message || '']}
            heading={kycVerified?.message || ''}
        />
    );
};

const KYCInvalid = ({
    open,
    setOpen,
    message,
    heading,
}: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    message: string;
    heading: string;
}) => {
    const history = useHistory();
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="note-modals">
            <div className="note-modals">
                <h3>{heading}</h3>
                <p>{message}</p>
                <div className="note-modals-btns">
                    <Button
                        className="customBtn"
                        onClick={() => {
                            setOpen(false);
                            history.goBack();
                        }}
                    >
                        OK
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};
